<template lang="pug">
  header#the-header: .container: h1(v-text="getHeadingText")
</template>

<script>
export default {
  name: 'TheHeader',
  // Computed ------------------------------------------------------------------
  computed: {
    getHeadingText () {
      const branded = this.$store.state.config.branded
      if (branded === 'anderida') return 'Получите портфель ценных бумаг за пару секунд'
      if (branded === 'ds') return 'Получите портфель ценных бумаг за пару секунд'
      if (branded === 'redcircule') return 'Получите портфель ценных бумаг за пару секунд'
      if (branded === 'scapital') return 'Получите портфель ценных бумаг за пару секунд'
      return 'Ваш секретный портфель здесь'
    }
  }
}
</script>
